// @ts-nocheck
import React from 'react';

import { Container } from './styles';

import { CustomButtonProps } from './types';

const CustomButton: React.FC<CustomButtonProps> = ({
  buttonType,
  children,
  iconLeft: IconLeft,
  iconRight: IconRight,
  ...props
}) => {
  return (
    <Container
      buttonType={buttonType}
      {...props}
      float={IconLeft ? 'left' : 'right'}
    >
      {IconLeft && <IconLeft size={22} />}
      {children}
      {IconRight && <IconRight size={22} />}
    </Container>
  );
};

export default CustomButton;
